(function($){
    function menu_open() {
        $('.burger_button-js').click(function(){
            $('.menu_burger').removeClass('menu_burger_closing').addClass('menu_burger_open');
            $('body').toggleClass('bg_blur');
            return false;
        });
    }

    function menu_close() {
        $('.menu_close-js').click(function(){
            $('.menu_burger').removeClass('menu_burger_open').addClass('menu_burger_closing');
            $('body').removeClass('bg_blur');
            return false;
        });

        $(document).click(function(event) {
            if (!$(event.target).closest('.menu_burger_wrapper_nav').length) {
                $('.menu_burger').removeClass('menu_burger_open').addClass('menu_burger_closing');
                $('body').removeClass('bg_blur');
            }
        });
    }

    function menu_close_on_link_click() {
        $('.menu_burger').on('click', 'a', function (e) {
            const href = $(this).attr('href');

            // Ferme le menu
            $('.menu_burger')
                .removeClass('menu_burger_open')
                .addClass('menu_burger_closing');
            $('body').removeClass('bg_blur');

            // Si lien ancre → on laisse le scroll se faire
            if (href && href.startsWith('#')) {
                // rien à bloquer
                return;
            }

            // Si lien avec ancre sur la même page (ex: /#section)
            if (href && href.includes('#')) {
                return;
            }
        });
    }

    function initSmoothScroll() {
        const header = document.querySelector('header');

        function checkScroll() {
            const scrollPosition = window.scrollY;
            if (scrollPosition > 50) {
                header.classList.add('scrolled-js');
            } else {
                header.classList.remove('scrolled-js');
            }
        }

        // Vérifie au chargement
        checkScroll();

        // Vérifie à chaque scroll
        window.addEventListener('scroll', checkScroll);
    }

    function showMore() {
        const buttons = document.querySelectorAll('.values_item_button-js');
        buttons.forEach(button => {
            button.addEventListener('click', function(e) {
                e.preventDefault();

                const parentLink = button.closest('.values_item');
                if (parentLink) {
                    parentLink.classList.add('active');
                }
            });
        });
    };

    function textAnim() {
        document.querySelectorAll('.text_anim').forEach(el => {
            const words = el.textContent.split(' ');
            el.innerHTML = words.map(word => `<span>${word}</span>`).join(' ');
        });
    };

    function initCircleSlider(swiperSelector, paginationSelector) {
        new Swiper(swiperSelector, {
            loop: true,
            grabCursor: true,
            centeredSlides: false,
            centeredSlidesBounds: true,
            pagination: { 
                el: paginationSelector,
                clickable: true,
            },
            navigation: {
                nextEl: ".circle_slider__control--next",
                prevEl: ".circle_slider__control--prev"
            },
            slidesPerView: 3,
            effect: "creative",
            creativeEffect: {
                perspective: true,
                limitProgress: 3,
                prev: {
                    translate: ["-90%", "20%", -100],
                    rotate: [0, 0, -20],
                    origin: "bottom"
                },
                next: {
                    translate: ["90%", "20%", -100],
                    rotate: [0, 0, 20],
                    origin: "bottom"
                }
            },
            breakpoints: {
                // écran ≤ 768px
                0: {
                    slidesPerView: 1,
                },
                // écran ≥ 769px
                769: {
                    slidesPerView: 3,
                }
            },
        });
    };

    function removeAnimationFirst() {
        const banners = document.querySelectorAll('.banner');

        banners.forEach(banner => {
            const nextElement = banner.nextElementSibling;

            if (nextElement && (nextElement.tagName === 'DIV' || nextElement.tagName === 'SECTION')) {
                // Sélectionne tous les éléments qui ont au moins une classe animatable
                const animatables = nextElement.querySelectorAll('[class*="animatable-"], .animatable-js');

                animatables.forEach(el => {
                    // Copie les classes dans un tableau pour éviter les problèmes en supprimant en boucle
                    Array.from(el.classList).forEach(cls => {
                        if (cls === 'animatable-js' || cls.startsWith('animatable-')) {
                        el.classList.remove(cls);
                        }
                    });
                });
            }
        });
    }

    doAnimations = function () {
        var n = $(window).scrollTop() + $(window).height(),
            e = $(".animatable-js");

        if (e.length === 0) {
            $(window).off("scroll", doAnimations);
        }

        e.each(function () {
            var t = $(this);
            // Vérifie si le haut de l'élément est visible
            if (t.offset().top < n - 20) {
                t.removeClass("animatable-js").addClass("animated-js");
            }
        });
    };


    $(function() {
        menu_open();
        menu_close();
        menu_close_on_link_click();
        initSmoothScroll();
        showMore();
        textAnim();
        removeAnimationFirst();
        
        // Initialisation des deux sliders
        initCircleSlider(".team_circle_slider__swiper-js", ".team_circle_slider__pagination-js");
        initCircleSlider(".gallery_circle_slider__swiper-js", ".gallery_circle_slider__pagination-js");
    });
    $(window).on("scroll", function () {
        doAnimations()
    })
})(jQuery); 